"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaDataFields = void 0;
const country_codes_json_1 = __importDefault(require("./country-codes.json"));
exports.MetaDataFields = {
    sessionId: {
        description: 'Randomly generated ID to identify a unique upflowy user',
        name: 'Session ID',
    },
    'location.referrer': {
        name: 'Referrer',
        description: 'The event that linked to your site and initiated the flow',
    },
    'location.country': {
        name: 'Country',
        description: 'Country as determined by IP address',
        allowedValues: country_codes_json_1.default.map(({ code, name }) => ({
            label: name,
            value: code,
        })),
    },
    'location.region': {
        name: 'Region',
        description: 'Region as determined by IP address',
    },
    'location.city': {
        name: 'City',
        description: 'City as determined by IP address',
    },
    typeOfUser: {
        name: 'Unique or returning user',
        description: 'Whether user has been to flow before',
        allowedValues: [
            { label: 'Unique User', value: 'unique' },
            { label: 'Returning User', value: 'returning' },
        ],
    },
    'operatingSystem.name': {
        name: 'Operating platform',
        description: 'Operating System E.g. "iOS", "Android"',
        allowedValues: [
            { label: 'iOS', value: 'iOS' },
            { label: 'Mac', value: 'Mac OS' },
            { label: 'Android', value: 'Android' },
            { label: 'Windows', value: 'Windows' },
        ],
    },
    'operatingSystem.version': {
        name: 'Operating platform version',
        description: 'Operating System Version"',
    },
    'device.type': {
        name: 'Device Type',
        description: 'Device type\tE.g. "Mobile", "Tablet", "Desktop"',
        allowedValues: [
            { label: 'Mobile', value: 'mobile' },
            { label: 'Tablet', value: 'tablet' },
            { label: 'Desktop', value: 'desktop' },
            { label: 'Wearable', value: 'wearable' },
            { label: 'Smart TV', value: 'smarttv' },
            { label: 'Embedded', value: 'embedded' },
            { label: 'Console', value: 'console' },
        ],
    },
    'utm.utm_source': {
        name: 'UTM_Source',
        description: 'Individual websites within a UTM Medium',
    },
    'utm.utm_medium': {
        name: 'UTM_Medium',
        description: 'What "Channel" the UTM is affiliated with - e.g. "Social", "Organic", "Paid", "Email",',
    },
    'utm.utm_term': {
        name: 'UTM_Term',
        description: 'Tracking specific keywords for paid organic campaigns',
    },
    'location.origin': {
        name: 'Origin',
        description: 'URL where the user came from',
    },
    'browser.name': {
        name: 'Browser',
        description: "User's browser name",
    },
    'browser.version': {
        name: 'Browser Version',
        description: "User's broswer version",
    },
    triggerType: {
        name: 'Trigger Type',
        description: 'Which trigger the user came from',
    },
    externalData: {
        name: 'External Data',
        description: 'The result returned from an external data source',
    },
};
//# sourceMappingURL=FieldTypes.js.map